{
  "version": 1,
  "asset_id": "445598cf-549b-4bc8-8416-cc611610eeae",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/445598cf-549b-4bc8-8416-cc611610eeae/maintenance-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/445598cf-549b-4bc8-8416-cc611610eeae/maintenance-hero.webp",
  "original_filename": "maintenance-hero.webp",
  "size": 48738,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:05Z"
}
